/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { buildUrl } from "../../utils/bindUrl";
import {
  IPlanningMaintenances,
  IResponseListPlanningMaintenances,
  IResponseShowPlanningMaintenances,
} from "../../interfaces/planningsMaintenances";

const BASE = "/plannings_maintenances";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listPlanningsMaintenances({
  filter,
  includes,
  page,
  limit,
  sort,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListPlanningMaintenances>(BASE, {
    params: { filter, includes, page, limit, select, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showPlanningMaintenances({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowPlanningMaintenances>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createPlanningMaintenances({
  planningMaintenances,
}: {
  planningMaintenances: IPlanningMaintenances;
}) {
  const { data } = await api.post<IResponseShowPlanningMaintenances>(BASE, {
    planningMaintenances,
  });
  return data;
}

export async function updatePlanningMaintenances({
  id,
  planningMaintenances,
}: {
  id: string | number;
  planningMaintenances: IPlanningMaintenances;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowPlanningMaintenances>(url, {
    planningMaintenances,
  });
  return data;
}

export async function deletePlanningMaintenances({
  id,
}: {
  id: string | number;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  await api.delete(url);
}
